module.exports = __webpack_public_path__ + "static/media/uzpildykite_paraiska.6df3b596.png";